import React, { useState, useEffect } from 'react'
import { List, Button, Space, Checkbox, Spin } from 'antd'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'

import ShareDealWithColleaguesForm from '../../Components/Forms/ShareDealWithColleaguesForm'
import PopupWrapper from './PopupWrapper'
import UsersActions from '../../Redux/UsersRedux'
import DealSharesActions from '../../Redux/DealSharesRedux'
import DealsActions from '../../Redux/DealsRedux'
import Images from '../../Images'
import './PopupPage.less'

function ShareDealWithColleaguesPopupPage(props) {
  const { colleagues, result, result_, fetching, match } = props;
  const { shareId } = match.params;
  const { dealId } = match.params;
  const { tab } = match.params;

  const [data, setData] = useState(null);
  const [users, setUsers] = useState([]);
  const [active, setActive] = useState(false);

  const history = useHistory();

  useEffect(() => {
    setData({
      existent: [],
      new: []
    });
    props.getColleagues(true);
  }, [0]);

  useEffect(() => {
    if (colleagues) {
      setUsers(colleagues.map(el => ({ id: el.id, name: el.name })));
    }
  }, [colleagues]);

  useEffect(() => {
    if (result || result_) {
      history.push('/home/deals');
    }
  }, [result, result_]);

  const handleSubmit = formData => {
    const newData = { ...data };
    newData.new = formData;
    if (shareId) {
      props.shareDealWithColleagues(shareId, newData);
    } else if (dealId) {
      props.shareDealWithColleagues_(dealId, newData);
    }
  }

  const changeView = () => {
    setActive(!active);
  }

  const selectUser = (value, checked) => {
    const newData = { ...data };
    if (checked) {
      newData.existent.push(value);
    } else {
      const index = newData.existent.findIndex(el => el === value);
      newData.existent.splice(index, 1);
    }
    setData(newData);
  }

  const sendInvite = () => {
    if (active) {
      return;
    } else {
      if (shareId) {
        props.shareDealWithColleagues(shareId, data);
      } else if (dealId) {
        props.shareDealWithColleagues_(dealId, data);
      }
    }
  }

  const setBackPath = () => {
    let path;
    if (shareId) {
      path = `/home/deal-share-info/${shareId}/${tab}`
    } else if (dealId) {
      path = `/home/deal-share-info-all/${dealId}/${tab}`
    }
    return path;
  }

  return (
    <PopupWrapper
      width={420}
      path={setBackPath()}
    >
      <Spin spinning={fetching} size="large">
        <div className="dialog-content dynamic" style={{ padding: '24px 48px' }}>
          <div className="dialog-title deal">Send to colleague(s)</div>
          <List
            itemLayout="horizontal"
            style={{ marginBottom: 24 }}
            dataSource={users}
            renderItem={item => (
              <List.Item>
                <List.Item.Meta
                  avatar={<img src={Images.user} alt="" />}
                  title={<span className="list-text">{item.name}</span>}
                />
                <div className="checkbox-wrap">
                  <Checkbox onChange={(e) => selectUser(item.id, e.target.checked)} />
                </div>
              </List.Item>
            )}
          />
          {
            active ?
              <ShareDealWithColleaguesForm
                onSubmit={handleSubmit}
                changeView={changeView}
              />
              :
              <Space style={{ margin: '24px 0' }}>
                <span className="link-tag underline" onClick={changeView}>Invite new Colleagues</span>
              </Space>
          }
          <div className="btn-footer" style={{ marginTop: 0 }}>
            <Button
              type="primary white"
              htmlType="submit"
              className="btn-primary"
              form="share-deal-with-colleagues-form"
              style={{ width: 172 }}
              disabled={!active && !data?.existent?.length}
              onClick={sendInvite}
            >
              Send Invite
          </Button>
          </div>
        </div>
      </Spin>
    </PopupWrapper>
  )
}

const mapStateToProps = (state) => {
  return {
    colleagues: state.users.investorColleagues,
    result: state.dealShares.dealInvestorSendColleaguesResult,
    result_: state.deals.dealInvestorSendColleaguesResult,
    fetching: state.dealShares.fetching
  }
}

const mapDispatchToProps = (dispatch) => ({
  getColleagues: (filter) => dispatch(UsersActions.investorColleaguesRequest(filter)),
  shareDealWithColleagues: (shareId, data) => dispatch(DealSharesActions.dealInvestorSendColleaguesRequest(shareId, data)),
  shareDealWithColleagues_: (dealId, data) => dispatch(DealsActions.dealInvestorSendColleaguesRequest_(dealId, data)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ShareDealWithColleaguesPopupPage)
